module.exports = __webpack_public_path__ + "img/ennetix-overview-search-bar.cad1a1c6.png";